import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { GcpServiceAccountAccesses } from "./accesses.ts";
import { GcpServiceAccountComponents } from "./components.ts";

const GcpServiceAccountFilters = {} as const satisfies AnyFilterSchema;
export type GcpServiceAccountFilters = typeof GcpServiceAccountFilters;

export const GcpServiceAccountRegistration = Registration({
  accesses: GcpServiceAccountAccesses,
  category: "resource",
  components: GcpServiceAccountComponents,
  docs: { install: "gcp-service-account-creator" },
  filters: GcpServiceAccountFilters,
  // Its only consumer is agentic access through the gateway, so it rides the
  // gateway's flag rather than carrying one of its own.
  itemKind: "project",
  label: "GCP Service Account Creator",
  logoUrl: "https://www.gstatic.com/cloud/images/navigation/icons.svg#cloudiam",
  maturity: "beta",
  // Never requested directly. An integration that needs an agent to hold a
  // Google identity reaches this one by delegation.
  requestType: "bridge",
  useMapping: [{ use: "iam_write", component: "iam-write" }],
});

registerIntegration("gcp-service-account", GcpServiceAccountRegistration);
